import { combineReducers } from 'redux';
import authUser from './auth/reducer';
import customization from './theme/reducer';

const reducers = combineReducers({
  authUser,
  customization
});

export default reducers;